// AppLoginGql.js
import { gql } from "@apollo/client";

export const SESSION_USER = gql`
fragment SessionUserData on SessionUser {
    sessionNote
    userNid
    useYn
    userId
    userName
    authClassInt
    classRank
    className
    dscId
    dscName
    dscIdAs
    dscNameAs
    comDcCd
    dcUseYn
    allDcYn
    handlerYn
    viewLevel
    initLat
    initLon
    jsonMapConf
    regTypeCd
    loginTime
    cvoUserId
    cvoToken
}
`;

export const GET_SESSION_DATA = gql`
${SESSION_USER}
query getSessionData {
    getSessionData {
        ...SessionUserData
    }
}
`;

/*

type Mutation {
	loginNewTop(userId:String!, password:String!): SessionUser
    maskDsc(dscId: String!, dscName: String!): SessionUser
}
*/

export const LOGIN_NEW_TOP = gql`
${SESSION_USER}
mutation loginNewTop($userId:String!, $password:String!) {
    loginNewTop(userId:$userId, password:$password) {
        ...SessionUserData
    }
}
`;

export const LOGIN_AS = gql`
${SESSION_USER}
mutation loginAs($userId: String!, $adminId: String!, $adminPassword: String!) {
    loginAs(userId: $userId, adminId: $adminId, adminPassword: $adminPassword) {
        ...SessionUserData
    }
}
`;

export const MASK_DSC = gql`
${SESSION_USER}
mutation maskDsc($dscId: String!, $dscName: String!) {
    maskDsc(dscId:$dscId, dscName:$dscName) {
        ...SessionUserData
    }
}
`;

export const LOGOUT_NEW_TOP = gql`
${SESSION_USER}
query logoutNewTop {
    logoutNewTop {
        ...SessionUserData
    }
}
`;

